import { render, staticRenderFns } from "./LegoControlCardAssignments.vue?vue&type=template&id=640e18bd&scoped=true"
import script from "./LegoControlCardAssignments.vue?vue&type=script&lang=js"
export * from "./LegoControlCardAssignments.vue?vue&type=script&lang=js"
import style0 from "./LegoControlCardAssignments.vue?vue&type=style&index=0&id=640e18bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640e18bd",
  null
  
)

export default component.exports